import { TeaConfig } from './tea.model';

export interface SelectedTeaConfig {
    studyTestId: number;
    teaConfig?: TeaConfig;
    userDefinedAbsoluteValue: any;
    userDefinedPercentageValue: any;
}

export class TeaConfigHelperMethods {

    static GetTeaSchema(tea: SelectedTeaConfig) {
        if (!tea) {
            return '';
        }

        if (tea.userDefinedAbsoluteValue || tea.userDefinedPercentageValue) {
            return 'User Defined';
        }

        return (tea && tea.teaConfig) ? tea.teaConfig.schema : '';
    }

    static GetTeaDescription(tea: SelectedTeaConfig, analyteUnitName = '' ) {
        if (!tea) {
            return '';
        }
        const isUserDefined = TeaConfigHelperMethods.IsSelectedTeaConfigUserDefined(tea);
        return TeaConfigHelperMethods.GetTranslatedGrammar(isUserDefined, tea.userDefinedAbsoluteValue, tea.userDefinedPercentageValue, tea.teaConfig, analyteUnitName);
    }

    static GetTeaGrammar(tea: SelectedTeaConfig) {
        if (!tea) {
            return '';
        }
        const isUserDefined = TeaConfigHelperMethods.IsSelectedTeaConfigUserDefined(tea);
        return TeaConfigHelperMethods.GetTranslatedGrammar(isUserDefined, tea.userDefinedAbsoluteValue, tea.userDefinedPercentageValue, tea.teaConfig);
    }

    static GetTranslatedGrammar(isUserDefined: boolean, absoluteValue, percentageValue, tea: TeaConfig, analyteUnitName = '') {
        if (isUserDefined) {
            return `${absoluteValue ? absoluteValue + ' ' + analyteUnitName : ''} ${percentageValue ? percentageValue + '%' : ''}`;
        } else if (tea) {
            return tea.translatedGrammar;
        }

        return ``;
    }

    static IsSelectedTeaConfigUserDefined(tea: SelectedTeaConfig) {
        const isUserDefined = tea && (tea.userDefinedAbsoluteValue || tea.userDefinedPercentageValue) ? true : false;
        return isUserDefined;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/contracts/common/selected-tea-config.model.ts